// ===== DEZAUTO THEME JS =====
document.addEventListener('DOMContentLoaded', function() {

  // ===== HERO SLIDER =====
  initHeroSlider();

  // ===== BRAND TREE TOGGLE =====
  initBrandTree();

  // ===== PRODUCT GALLERY =====
  initProductGallery();

  // ===== QUANTITY INPUTS =====
  initQuantityInputs();

  // ===== CART QUANTITY =====
  initCartQuantity();
});

function initHeroSlider() {
  const sliders = document.querySelectorAll('[data-section-type="hero-slider"]');

  sliders.forEach(function(slider) {
    const slides = slider.querySelectorAll('.slide');
    if (slides.length === 0) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const intervalSec = parseInt(slider.dataset.interval, 10) || 5;
    const dots = slider.querySelectorAll('.slider-dot');
    const prevBtn = slider.querySelector('.slider-arrow--prev');
    const nextBtn = slider.querySelector('.slider-arrow--next');

    let current = 0;
    let timer = null;

    function showSlide(index) {
      slides.forEach(function(s, i) {
        s.classList.toggle('slide--active', i === index);
      });
      if (dots.length > 0) {
        dots.forEach(function(d, i) {
          d.classList.toggle('active', i === index);
        });
      }
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % slides.length);
    }

    function prevSlide() {
      showSlide((current - 1 + slides.length) % slides.length);
    }

    // Ensure first slide is visible at start
    showSlide(0);

    if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); resetTimer(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); resetTimer(); });

    if (dots.length > 0) {
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { showSlide(i); resetTimer(); });
      });
    }

    function startTimer() {
      if (autoplay && slides.length > 1) {
        timer = setInterval(nextSlide, intervalSec * 1000);
      }
    }

    function resetTimer() {
      if (timer) { clearInterval(timer); startTimer(); }
    }

    startTimer();
  });
}

function initBrandTree() {
  document.querySelectorAll('.brand-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const list = this.nextElementSibling;
      if (list && list.classList.contains('model-list')) {
        list.classList.toggle('open');
      }
    });
  });
}

function initProductGallery() {
  const featured = document.getElementById('FeaturedImage');
  if (!featured) return;

  document.querySelectorAll('.thumb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      featured.src = this.dataset.image;
      document.querySelectorAll('.thumb-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });
}

function initQuantityInputs() {
  document.querySelectorAll('.quantity-input-group').forEach(function(group) {
    const input = group.querySelector('.qty-input');
    const minus = group.querySelector('.qty-minus');
    const plus = group.querySelector('.qty-plus');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });
}

function initCartQuantity() {
  // Auto-update cart on quantity change
  document.querySelectorAll('[data-cart-item]').forEach(function(row) {
    const input = row.querySelector('[data-quantity-input]');
    if (!input) return;

    input.addEventListener('change', function() {
      if (parseInt(this.value, 10) <= 0) {
        var removeLink = row.querySelector('.remove-btn');
        if (removeLink) window.location.href = removeLink.href;
      }
    });
  });
}
